export const styles = {
  overlay: {
    position: 'fixed',
    inset: 0,
    background: 'rgba(17, 24, 39, 0.45)',
    zIndex: 9999,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 16,
  },

  modal: {
    width: 'min(720px, 100%)',
    background: '#FFFFFF',
    borderRadius: 12,
    boxShadow: '0 20px 60px rgba(0,0,0,0.2)',
    border: '1px solid #E5E7EB',
  },

  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '18px 18px 12px 18px',
  },

  titleRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    fontSize: 18,
    fontWeight: 700,
    color: '#111827',
  },

  iconWarnWrap: {
    width: 28,
    height: 28,
    borderRadius: 999,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#FEF3C7',
    border: '1px solid #FDE68A',
  },

  closeBtn: {
    width: 32,
    height: 32,
    borderRadius: 8,
    border: '1px solid #E5E7EB',
    background: '#FFFFFF',
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  closeBtnDisabled: {
    opacity: 0.6,
    cursor: 'not-allowed',
  },

  body: {
    padding: '0 18px 16px 18px',
  },

  description: {
    marginTop: 6,
    color: '#6B7280',
    fontSize: 14,
    lineHeight: '20px',
  },

  preview: {
    marginTop: 14,
    background: '#F9FAFB',
    border: '1px solid #EEF2F7',
    borderRadius: 10,
    padding: 14,
  },

  previewTitle: {
    fontWeight: 700,
    color: '#111827',
    marginBottom: 4,
  },

  previewSub: {
    color: '#6B7280',
    fontSize: 13,
  },

  footer: {
    padding: '14px 18px 18px 18px',
    display: 'flex',
    justifyContent: 'flex-end',
    gap: 10,
  },

  dangerButton: {
    background: '#DC2626',
    border: '1px solid #DC2626',
    color: '#FFFFFF',
    borderRadius: 10,
    padding: '10px 14px',
  },

  dangerButtonLoading: {
    opacity: 0.9,
  },

  dangerButtonContent: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 8,
  },

  dangerButtonText: {
    color: '#FFFFFF',
    fontWeight: 700,
    margin: 0,
    lineHeight: '18px',
  },

  warnBox: {
    marginTop: 14,
    width: '100%',
    padding: '12px 14px',
    borderRadius: 10,
    border: '1px solid #FCA5A5',
    backgroundColor: '#FEF2F2',

    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 10,
  },

  warnText: {
    color: '#DC2626',
    fontWeight: 600,
    fontSize: 13,
    lineHeight: '18px',
    textAlign: 'center',
  },
};